import { createStore } from "vuex";

import auth_module from "@/store/auth/store";
import master_module from "@/store/master/store";
import participant_module from "@/store/participant/store";
import order_module from "@/store/order/store";
import quiz_module from "@/store/quiz/store";

import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default createStore({
  actions,
  mutations,
  getters,
  state,
  modules: {
    auth: auth_module,
    master: master_module,
    quiz: quiz_module,
    participant_module,
    order_module
  },
  strict: false
});
